// Recent activity: the connected wallets' intents (`GET /intents?escrow_user=`, every source
// chain), merged newest first, and what each one means to the user in a word.

import { intentsOf, type IntentRow } from "./api";
import { progress } from "./progress";

/** Rows of several wallets as one list: each intent once, newest first, at most `limit`. */
export function mergeActivity(lists: IntentRow[][], limit = 12): IntentRow[] {
  const seen = new Map<string, IntentRow>();
  for (const l of lists) for (const r of l) if (!seen.has(r.intent_hash)) seen.set(r.intent_hash, r);
  return [...seen.values()].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)).slice(0, limit);
}

export type Badge = { label: string; tone: "ok" | "pending" | "warn" };

/** An intent's status for the activity list: done for the user (paid, or credited on Jupnet),
 *  refunded, refunding, or in progress. */
export function badgeOf(row: IntentRow): Badge {
  const p = progress(row, []);
  if (p.lane === "refund") return row.state === "refunded" ? { label: "Refunded", tone: "warn" } : { label: "Refunding", tone: "pending" };
  if (p.userDone) return { label: "Completed", tone: "ok" };
  return { label: "In progress", tone: "pending" };
}

/** Every listed wallet's intents (a wallet the api refuses is left out). */
export async function loadActivity(api: string, owners: string[], f: typeof fetch = fetch): Promise<IntentRow[]> {
  const lists = await Promise.all(owners.map((o) => intentsOf(api, o, undefined, 12, f).catch(() => [] as IntentRow[])));
  return mergeActivity(lists);
}
